import './config/sentry.ts'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from 'config/api'
import 'hooks/settings'
import { AuthenticationContextProvider } from './components/core/AuthContext.tsx'
import { Entrypoint } from './components/core/Entrypoint.tsx'
import './index.css'
import { startDarkModeWatcher } from 'util/darkMode.ts'
import { startFirestoreDocTracker } from 'util/firestore/counter.ts'
import './util/wdio.helpers'
import {
  installEnvironmentBackground,
  isProdOrBeta,
} from 'config/environment.ts'
import { startFetchWrapper } from 'util/fetchWrapper.ts'
import { startDocumentCounter } from '@breakoutlearning/firebase-repository/firestore-mobx'

startDarkModeWatcher()

startFetchWrapper()

// Start Firestore document tracker and document counter in non-prod envs
if (!isProdOrBeta()) {
  startFirestoreDocTracker()
  startDocumentCounter()
}

installEnvironmentBackground()

// This is a handler for a situation where the app is running, it's requesting
// a new chunk, but we've deployed a new version of the app and that chunk is
// not available. This will force a reload of the app. Preloads only happen
// on navigation, so this is safe.
// Disabled as the service worker has taken over
// window.addEventListener('vite:preloadError', (e) => {
//   e.preventDefault()
//   window.location.reload()
// })

createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <AuthenticationContextProvider>
      <Entrypoint />
    </AuthenticationContextProvider>
  </QueryClientProvider>
)
